// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';

import { tns } from "tiny-slider/src/tiny-slider";

var slider = null;

export default class HpTinySlider extends WebComponent {

	didMount() {
		var _self = this;
		slider = tns({
			container: '.slider__list',
			controlsContainer: '.slider__controls',
			mode: 'gallery',
			animateIn: null,
			speed: 500,
			items: 1,
			loop: false,
			slideBy: 'page',
			mouseDrag: true
		});

		slider.events.on('indexChanged', function(){
			_self.handleUpdateGallerySlidePositions(null);
		});
	}

	handleUpdateGallerySlidePositions = () => {
		var info =  slider.getInfo(), indexPrev = info.indexCached, indexCurrent = info.index;

		// update style based on index
		info.slideItems[indexCurrent].classList.remove('slideInRight');
		info.slideItems[indexCurrent].classList.remove('slideInLeft');
		info.slideItems[indexPrev].classList.remove('slideInRight');
		info.slideItems[indexPrev].classList.remove('slideInLeft');

		if(indexPrev < indexCurrent) {
			info.slideItems[indexCurrent].classList.add('slideInRight');
		}
		if(indexPrev > indexCurrent) {
			info.slideItems[indexCurrent].classList.add('slideInLeft');
		}
		info.slideItems[indexPrev].classList.remove('tns-slide-active');
		info.slideItems[indexCurrent].classList.add('tns-slide-active');
	}
}



// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/TinySliders/HpTinySlider.js